import { Tooltip, message } from 'antd';
import { ToolbarIcon } from '../ToolbarIcon';
import { useTranslate } from '@tolgee/react';
import { getShopeeInviteFollowerUrl } from 'services/api/conversation';
import useIM from 'hooks/business/im/useIM';

export interface ShopeeFollowProps {
  conversation: Conversation.Conversation;
  onSend?: () => void;
}

export const ShopeeFollow = (props: ShopeeFollowProps) => {
  const {
    conversation: { storeId, conversationId },
    onSend,
  } = props;
  const { t } = useTranslate();
  const { sendImage } = useIM();

  return (
    <Tooltip title={t('scene.chatWorkspace.messageEditor.action.inviteFollow')}>
      <ToolbarIcon
        icon="follow"
        onClick={() =>
          getShopeeInviteFollowerUrl(storeId)
            .then((data) =>
              sendImage(conversationId, data, data.imgUrl, {
                followerMsg: true,
              }).finally(() => {
                onSend && onSend();
              }),
            )
            .catch(() => {
              message.error(t('common.feedback.fetchFailed'));
            })
        }
      />
    </Tooltip>
  );
};
